import { FormGroup } from '@angular/forms';
import { FormFieldsGeneratorService } from './../form-helpers/form-fields-generator.service';
import { FormStateChange, FormStateChangeService, StateInputFields } from '../form-state/form-state-change.service';
import { Injectable } from '@angular/core';
import FormFieldsSchemaService from '../form-helpers/form-fields-schema.service';
import { IdTypeEnum } from '../../models/cartDetails/idType.enum';

@Injectable()
export class UserDataFormService {
  public idType: IdTypeEnum;
  public showOtherInstallationAddressSection = false;
  public formFields: any;
  public activeForm: FormGroup;

  constructor(
    private formFieldsSchemaService: FormFieldsSchemaService,
    private formStateChangeService: FormStateChangeService,
    private formsGenerator: FormFieldsGeneratorService
  ) {
    this.formFields = this.formFieldsSchemaService.fields;

    this.formsGenerator.watchActiveForm().subscribe(form => {
      this.activeForm = form;
    });
  }

  public onContractAddressChange(): void {
    this.validateContractAddressForm();

    this.formStateChangeService.setField(
      new FormStateChange(
        StateInputFields.CONTRACT_ADDRESS_FORM_VALUES,
        this.activeForm?.controls.contractAddress.value
      )
    );
  }

  public onOtherDeliveryAddressInputChange(): void {
    this.validateDeliveryAddressForm();

    this.formStateChangeService.setField(
      new FormStateChange(
        StateInputFields.PAYMENT_INVOICE_ADDRESS_FORM_VALUES,
        this.activeForm?.controls.deliveryAddress.value
      )
    );
  }

  private validateCorrespondenceAddressForm(): void {
    // #correspondence-address
    this.formStateChangeService.setField(
      new FormStateChange(
        StateInputFields.CORRESPONDENCE_OTHER_ADDRESS_FORM_VALIDATE,
        this.activeForm?.controls.correspondenceAddress.valid
      )
    );
  }

  public onOtherCorrespondenceAddressInputChange(): void {
    this.validateCorrespondenceAddressForm();

    this.formStateChangeService.setField(
      new FormStateChange(
        StateInputFields.CORRESPONDENCE_OTHER_ADDRESS_FORM_VALUES,
        this.activeForm?.controls.correspondenceAddress.value
      )
    );
  }

  private validateContractAddressForm(): void {
    // #shipment-address
    this.formStateChangeService.setField(
      new FormStateChange(
        StateInputFields.CONTRACT_ADDRESS_FORM_VALIDATE,
        this.activeForm?.controls.contractAddress.valid
      )
    );
  }

  private validateDeliveryAddressForm(): void {
    // #address-other-content
    this.formStateChangeService.setField(
      new FormStateChange(
        StateInputFields.PAYMENT_INVOICE_FORM_VALIDATE,
        this.activeForm?.controls.deliveryAddress.valid
      )
    );
  }

  public onOtherInstallationAddressInputChange(): void {
    this.validateInstallationAddressForm();

    this.formStateChangeService.setField(
      new FormStateChange(
        StateInputFields.INSTALLATION_OTHER_ADDRESS_FORM_VALUES,
        this.activeForm?.controls.installationAddress.value
      )
    );
  }

  private validateInstallationAddressForm(): void {
    // #installation-address-wrapper
    this.formStateChangeService.setField(
      new FormStateChange(
        StateInputFields.INSTALLATION_OTHER_ADDRESS_FORM_VALIDATE,
        this.activeForm?.controls.installationAddress.valid
      )
    );
  }
}
